
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <g clip-path="url(#clip0_756_5318)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.4453 1.63018C5.56894 1.44471 5.7771 1.33331 6 1.33331H10C10.2229 1.33331 10.4311 1.44471 10.5547 1.63018L11.6901 3.33331H14C14.5304 3.33331 15.0391 3.54403 15.4142 3.9191C15.7893 4.29417 16 4.80288 16 5.33331V12.6666C16 13.1971 15.7893 13.7058 15.4142 14.0809C15.0391 14.4559 14.5304 14.6666 14 14.6666H2C1.46957 14.6666 0.960859 14.4559 0.585786 14.0809C0.210714 13.7058 0 13.1971 0 12.6666V5.33331C0 4.80288 0.210714 4.29417 0.585786 3.9191C0.960859 3.54403 1.46957 3.33331 2 3.33331H4.30988L5.4453 1.63018ZM6.35679 2.66665L5.22137 4.36978C5.09772 4.55525 4.88957 4.66665 4.66667 4.66665H2C1.82319 4.66665 1.65362 4.73688 1.5286 4.86191C1.40357 4.98693 1.33333 5.1565 1.33333 5.33331V12.6666C1.33333 12.8435 1.40357 13.013 1.5286 13.1381C1.65362 13.2631 1.82319 13.3333 2 13.3333H14C14.1768 13.3333 14.3464 13.2631 14.4714 13.1381C14.5964 13.013 14.6667 12.8435 14.6667 12.6666V5.33331C14.6667 5.1565 14.5964 4.98693 14.4714 4.86191C14.3464 4.73688 14.1768 4.66665 14 4.66665H11.3333C11.1104 4.66665 10.9023 4.55525 10.7786 4.36978L9.64321 2.66665H6.35679Z"
      fill="#4B4C52"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 6.66665C6.89543 6.66665 6 7.56208 6 8.66665C6 9.77122 6.89543 10.6666 8 10.6666C9.10457 10.6666 10 9.77122 10 8.66665C10 7.56208 9.10457 6.66665 8 6.66665ZM4.66667 8.66665C4.66667 6.8257 6.15905 5.33331 8 5.33331C9.84095 5.33331 11.3333 6.8257 11.3333 8.66665C11.3333 10.5076 9.84095 12 8 12C6.15905 12 4.66667 10.5076 4.66667 8.66665Z"
      fill="#4B4C52"
    />
  </g>
  <defs>
    <clipPath id="clip0_756_5318">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</svg>
